// extracted by mini-css-extract-plugin
module.exports = {"container":"GlobalLoadingIndicator_container__2NIAZ","logo":"GlobalLoadingIndicator_logo__2Axvc","sending":"GlobalLoadingIndicator_sending__TCUxu"};